import { ReactElement, useState } from "react";
import { useIntl } from "react-intl";
import { LatLngExpression } from "leaflet";
import { IconChevronRight } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import { actions } from "../../i18n/sharable-defs";
import { MapContainer, MapMarker } from "../../bundles/map";
import Button from "./button";
import "./map-blocker.scss";

type Props = {
  className?: string,
  label?: string;
  center: LatLngExpression;
  zoom?: number;
  children?: ReactElement<typeof MapMarker> | ReactElement<typeof MapMarker>[]
}

const MapBlocker = ({ className, label, center, zoom = 15 , children }: Props) => {

  const intl = useIntl();
  const [ inited, setInited ] = useState<boolean>(false);

  const wrapperClasses = classNames("map-blocker", className, { loaded: inited });

  if (!inited)
    return (
      <div className={wrapperClasses}>
        <div className="loader">
          {!!label && <p>{label}</p>}
          <Button type="button"
                  className="cream bold with-icon"
                  onClick={() => setInited(true)}>
            {intl.formatMessage(actions.showMap)}
            <IconChevronRight />
          </Button>
        </div>
      </div>);

  return (
    <div className={wrapperClasses}>
      <MapContainer className="map-container" center={center} zoom={zoom}>
        {/*@ts-ignore*/}
        {children}
      </MapContainer>
    </div>);

};

export default MapBlocker;
